import React from 'react'
import glamorous from 'glamorous'
import PropTypes from 'prop-types'

import { SearchBar } from '../../components/search-bar'

const NoResultsContainer = glamorous.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  marginTop: '130px',
})

const LocationImg = glamorous.img({
  height: '92px',
  width: '92px',
})

const Title = glamorous.div({
  maxWidth: '602px',
  color: '#2C2E2F',
  fontFamily: 'PayPalSansBig-Regular',
  fontSize: '32px',
  lineHeight: '40px',
  textAlign: 'center',
  margin: '54px auto 36px',
})

const Subtitle = glamorous.div({
  color: '#2C2E2F',
  fontFamily: 'PayPal Sans Big',
  fontSize: '16px',
  lineHeight: '24px',
  textAlign: 'center',
  marginBottom: '12px',
})

const NoSearchResults = ({
  title,
  subtitle,
  searchLabel,
  onSubmit,
  enableSeeYourLocation,
  currentLocationLabel,
  setCurrentBrowserLoccation,
}) => {
  return (
    <NoResultsContainer>
      <LocationImg src="https://www.paypalobjects.com/paypal-ui/illustrations/svg/location.svg" />
      <Title>{title}</Title>
      <Subtitle>{subtitle}</Subtitle>
      <SearchBar
        placeholder={searchLabel}
        onSubmit={onSubmit}
        enableSeeYourLocation={enableSeeYourLocation}
        currentLocationLabel={currentLocationLabel}
        setCurrentBrowserLoccation={setCurrentBrowserLoccation}
      />
    </NoResultsContainer>
  )
}

NoSearchResults.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  searchLabel: PropTypes.string,
  onSubmit: PropTypes.func,
  enableSeeYourLocation: PropTypes.bool,
  currentLocationLabel: PropTypes.string,
  setCurrentBrowserLoccation: PropTypes.func,
}

export default NoSearchResults
